var _filter, _filter2, _rect, _g, _circle, _circle2, _circle3, _circle4, _g2, _g3, _g4, _g5, _polygon, _polygon2, _g6, _path, _polygon3, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 450",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f0f23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#1a1a3e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0d0d1a"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glowPurple",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#7c3aed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#a855f7"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glowCyan",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#06b6d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#22d3ee"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glowOrange",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f97316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#fb923c"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "softGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    stroke: "#7c3aed"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 50,
    x2: 800,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 800,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 150,
    x2: 800,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 800,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 250,
    x2: 800,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 800,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 350,
    x2: 800,
    y2: 350
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 400,
    x2: 800,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 450
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 450
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 450
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 450
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 450
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 0,
    x2: 600,
    y2: 450
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 0,
    x2: 700,
    y2: 450
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 80,
    r: 3,
    fill: "#22d3ee",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "80;70;80",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 120,
    r: 2,
    fill: "#a855f7",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "120;130;120",
    dur: "2.5s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 350,
    r: 4,
    fill: "#fb923c",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "350;340;350",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 380,
    r: 2,
    fill: "#22d3ee",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "380;390;380",
    dur: "3.5s",
    repeatCount: "indefinite"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 225)",
    filter: "url(#softGlow)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 80,
    ry: 65,
    fill: "none",
    stroke: "url(#glowPurple)",
    strokeWidth: 2,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 60,
    ry: 48,
    fill: "none",
    stroke: "url(#glowCyan)",
    strokeWidth: 1.5,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -30,
    cy: -20,
    r: 8,
    fill: "#7c3aed",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: -25,
    r: 6,
    fill: "#06b6d4",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 15,
    r: 10,
    fill: "#a855f7",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -35,
    cy: 25,
    r: 5,
    fill: "#22d3ee",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 20,
    r: 7,
    fill: "#7c3aed",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: -20,
    x2: 25,
    y2: -25,
    stroke: "#22d3ee",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: -20,
    x2: 0,
    y2: 15,
    stroke: "#a855f7",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: -25,
    x2: 0,
    y2: 15,
    stroke: "#7c3aed",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 15,
    x2: -35,
    y2: 25,
    stroke: "#22d3ee",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 15,
    x2: 35,
    y2: 20,
    stroke: "#a855f7",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 45,
    fill: "none",
    stroke: "#7c3aed",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "45;90;45",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0;0.5",
    dur: "3s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 200)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -30,
    rx: 40,
    ry: 12,
    fill: "none",
    stroke: "url(#glowCyan)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40,-30 L-40,30 Q-40,42 0,42 Q40,42 40,30 L40,-30",
    fill: "none",
    stroke: "url(#glowCyan)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 30,
    rx: 40,
    ry: 12,
    fill: "none",
    stroke: "url(#glowCyan)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 40,
    ry: 12,
    fill: "none",
    stroke: "url(#glowCyan)",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 75,
    textAnchor: "middle",
    fill: "#22d3ee",
    fontFamily: "monospace",
    fontSize: 12
  }, "PostgreSQL"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(680, 200)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -45,
    width: 90,
    height: 70,
    rx: 5,
    fill: "none",
    stroke: "url(#glowOrange)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: 5,
    width: 12,
    height: 15,
    fill: "#f97316",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -10,
    width: 12,
    height: 30,
    fill: "#fb923c",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -25,
    width: 12,
    height: 45,
    fill: "#f97316",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: -5,
    width: 12,
    height: 25,
    fill: "#fb923c",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "-29,-5 -12,-20 5,-35 22,-15",
    fill: "none",
    stroke: "#fcd34d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 55,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "monospace",
    fontSize: 12
  }, "Firebase"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170,200 Q280,180 310,225",
    fill: "none",
    stroke: "url(#glowCyan)",
    strokeWidth: 2,
    strokeDasharray: "5,5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "10;0",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M630,200 Q520,180 490,225",
    fill: "none",
    stroke: "url(#glowOrange)",
    strokeWidth: 2,
    strokeDasharray: "5,5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "10;0",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "305,220 315,225 305,230",
    fill: "#22d3ee"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "495,220 485,225 495,230",
    fill: "#fb923c"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 380)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -25,
    width: 120,
    height: 45,
    rx: 8,
    fill: "none",
    stroke: "url(#glowPurple)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45,
    y1: -10,
    x2: 45,
    y2: -10,
    stroke: "#a855f7",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45,
    y1: 0,
    x2: 30,
    y2: 0,
    stroke: "#a855f7",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45,
    y1: 10,
    x2: 35,
    y2: 10,
    stroke: "#a855f7",
    strokeWidth: 2,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 40,
    textAnchor: "middle",
    fill: "#a855f7",
    fontFamily: "monospace",
    fontSize: 11
  }, "Analytics Report"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400,290 L400,345",
    fill: "none",
    stroke: "url(#glowPurple)",
    strokeWidth: 2,
    strokeDasharray: "5,5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "10;0",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "395,340 400,350 405,340",
    fill: "#a855f7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 55,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "system-ui, sans-serif",
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: 1
  }, "\n    LLM-Powered Analytics\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 82,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    From Raw Data to Actionable Insights\n  ")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/hero-image.8795398e5d7d4b5c211f1d7d7d2d950f.svg";
export { ForwardRef as ReactComponent };